
import utils from '@/utils';
import api from '@/api/error';
import { defineComponent } from 'vue';

interface IState {
  logId: number,
  uuid: string,
  message: string | null,
  stackTrace: string,
  addDate: Date,
}

export default defineComponent({
  data() {
    return {
      logId: utils.toInt(this.$route.query.logId),
      uuid: this.$route.query.uuid,
      message: this.$route.query.message,
      stackTrace: '',
      addDate: new Date(),
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.logId, (res) => {
        this.message = `${res.error.summary} ${res.error.message}`;
        this.stackTrace = res.error.stackTrace;
        this.addDate = res.error.addDate;
      });
    },
  },
  mounted() {
    if (this.logId > 0) {
      this.apiGet();
    } else if (this.uuid) {
      this.message = sessionStorage.getItem(this.uuid);
    }
    utils.loading(false);
  },
});
